<app-app-section [sectionInfo]="introSection"></app-app-section>

<!-- <app-card-cta [cardInfo]="reservaSesion"></app-card-cta> -->

<!-- RENOVACION VISADO -->
<!-- <app-app-section-accordion [sectionInfo]="renovacionVisado"></app-app-section-accordion> -->

<!-- PERMISO TRABAJO -->
<!-- <app-app-section-accordion [sectionInfo]="permisoTrabajo"></app-app-section-accordion> -->

<!-- RESERVA SESION LEGAL -->
<div class="card">
    <div>
      <h2 class="webapp-title-secondary">Otros Procesos Legales</h2>
      <p>Además de las renovaciones de visado y permisos de trabajo, nuestro equipo legal puede asistirte con otros procesos como:</p>
      <ul>
        <li>Solicitud de residencia permanente.</li>
        <li>Trámites de nacionalidad.</li>
        <li>Asistencia en casos de legalidad laboral.</li>
        <li>Consultas sobre derechos y deberes como residente en España.</li>
      </ul>
    </div>
</div>
  
<!-- <section>
  <h2>Renovación de Visado de Estudiante</h2>
  <p>La renovación de tu visado de estudiante en España implica varios pasos importantes. A continuación, te presentamos el proceso completo:</p>
  <ol>
    <li>Reunir todos los documentos necesarios: pasaporte, visado actual, comprobante de matrícula, seguro médico, y comprobante de medios económicos.</li>
    <li>Completar el formulario de solicitud correspondiente.</li>
    <li>Solicitar una cita en la oficina de extranjería más cercana.</li>
    <li>Presentar tu solicitud y documentos en la cita.</li>
    <li>Esperar la resolución de tu solicitud.</li>
  </ol>
</section> -->

<!-- <section>
  <h2>Permisos de Trabajo</h2>
  <p>Si deseas trabajar mientras estudias en España, necesitarás un permiso de trabajo. Aquí te explicamos cómo obtenerlo:</p>
  <ol>
    <li>Contar con un contrato de trabajo.</li>
    <li>Solicitar una cita en la oficina de extranjería.</li>
    <li>Presentar tu solicitud junto con el contrato de trabajo y otros documentos requeridos.</li>
    <li>Esperar la resolución de tu solicitud.</li>
  </ol>
</section> -->